// 是否是助教端
const isTeach = import.meta.env.VITE_APP_MODE === 'teach';

// 定义导航栏和标签栏可见的路由白名单
export const routeWhiteList: readonly string[] = isTeach
  ? [
    'Profile', // 个人中心
    'Orders', // 我的订单
  ]
  : [
    'Home', // 首页
    'Profile', // 个人中心
    'Orders', // 我的订单
  ];

// 助教端路由无需检验的路由
export const teachRouteWhiteList: readonly string[] = [
  '/login', // 登录页
  '/login-register', // 登录注册页
  '/register', // 注册页
  '/empty', // 空页面（如缺省页）
  '/invite', // 邀请页
  '/address-select', // 地址选择页
  '/under-review', // 审核中
  '/promo', // 促销落地页
  '/promo/cuebuddy', // 促销活动页
  '/promo/wine', // 促销活动页
  '/profile'
];
